
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cc0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cc0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $fJDR9 = parcelRequire("fJDR9");
"use strict";
const $09e991522ca7e64e$var$buttonsLang = document.querySelectorAll(".language__button");
$09e991522ca7e64e$var$buttonsLang.forEach((button)=>{
    button.addEventListener("click", ()=>{
        $09e991522ca7e64e$var$changeLanguageSwitherStyle(button.value);
        $09e991522ca7e64e$var$changeLanguage(button.value);
    });
});
// змінення стилів для кнопок
function $09e991522ca7e64e$var$changeLanguageSwitherStyle(lang) {
    $09e991522ca7e64e$var$buttonsLang.forEach((button)=>{
        if (button.value === lang) button.classList.add("language__button--active");
        else button.classList.remove("language__button--active");
    });
}
// змінення мови для тексту
function $09e991522ca7e64e$var$changeLanguage(lang) {
    for(let key in 0, $fJDR9.default)document.querySelectorAll(".lng-" + key).forEach((element)=>{
        element.innerHTML = (0, $fJDR9.default)[key][lang];
    });
}
// слайдер
const $09e991522ca7e64e$var$swiper = new Swiper(".swiper", {
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 56,
    slidesPerColumnFill: "column",
    navigation: {
        nextEl: ".swiper-feature__button-next",
        prevEl: ".swiper-feature__button-prev"
    },
    breakpoints: {
        1280: {
            slidesPerView: 2,
            spaceBetween: 56,
            grid: {
                rows: 2
            }
        }
    }
});
const $09e991522ca7e64e$var$swiperCurrentSlide = document.querySelector(".swiper-feature__curent");
const $09e991522ca7e64e$var$swiperAllSlides = document.querySelector(".swiper-feature__total");
const $09e991522ca7e64e$var$swiperBtnPrev = document.querySelector(".swiper-feature__button-prev");
const $09e991522ca7e64e$var$swiperBtnNext = document.querySelector(".swiper-feature__button-next");
$09e991522ca7e64e$var$swiperAllSlides.innerHTML = $09e991522ca7e64e$var$swiper.slides.length > 9 ? $09e991522ca7e64e$var$swiper.slides.length : "0" + $09e991522ca7e64e$var$swiper.slides.length;
function $09e991522ca7e64e$var$updateNavigationButtons() {
    $09e991522ca7e64e$var$swiper.realIndex > 0 ? $09e991522ca7e64e$var$swiperBtnPrev.classList.add("swiper-feature__button--active") : $09e991522ca7e64e$var$swiperBtnPrev.classList.remove("swiper-feature__button--active");
    $09e991522ca7e64e$var$swiper.realIndex === $09e991522ca7e64e$var$swiper.slides.length - 1 ? $09e991522ca7e64e$var$swiperBtnNext.classList.remove("swiper-feature__button--active") : $09e991522ca7e64e$var$swiperBtnNext.classList.add("swiper-feature__button--active");
}
function $09e991522ca7e64e$var$updateCurrentSlide() {
    let currentSlide = $09e991522ca7e64e$var$swiper.realIndex + 1;
    $09e991522ca7e64e$var$swiperCurrentSlide.innerHTML = currentSlide > 9 ? currentSlide : "0" + currentSlide;
}
$09e991522ca7e64e$var$updateCurrentSlide();
$09e991522ca7e64e$var$updateNavigationButtons();
$09e991522ca7e64e$var$swiper.on("slideChange", function() {
    $09e991522ca7e64e$var$updateCurrentSlide();
    $09e991522ca7e64e$var$updateNavigationButtons();
});
// анімації
AOS.init();
AOS.init({
    duration: 800,
    easing: "ease-out"
});


//# sourceMappingURL=index.cac37df2.js.map
